/* VÆRK — theme.js
   Ingen afhængigheder. Alt er progressive enhancement:
   virker uden JS, bare uden skuffe og crossfade. */
(function () {
  'use strict';

  /* Priser formateres efter butikkens eget valutaformat (Indstillinger →
     Butiksoplysninger). Shopify leverer ikke længere en formatMoney på
     butikssiden, så den ligger her og bruges også af dela-ui.js. */
  var money = function (cents) {
    var fmt = window.themeMoneyFormat || '{{amount_with_comma_separator}} kr';
    var n = Number(cents) || 0;
    var tal = function (dec, tus, komma) {
      var v = (n / 100).toFixed(dec).split('.');
      v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, tus);
      return v[1] ? v[0] + komma + v[1] : v[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return tal(2, ',', '.');
        case 'amount_no_decimals': return tal(0, ',', '.');
        case 'amount_with_comma_separator': return tal(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return tal(0, '.', ',');
        case 'amount_with_space_separator': return tal(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return tal(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return tal(2, "'", '.');
        default: return tal(2, '.', ',');
      }
    });
  };
  window.dsMoney = money;

  /* ------------------------------------------------ mobilmenu */
  function initMobileNav() {
    var nav = document.querySelector('[data-mnav]');
    if (!nav) return;
    var open = function (state) {
      nav.setAttribute('data-open', state ? 'true' : 'false');
      document.documentElement.style.overflow = state ? 'hidden' : '';
      if (state) {
        var first = nav.querySelector('a, button');
        if (first) first.focus();
      }
    };
    document.querySelectorAll('[data-mnav-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(true); });
    });
    document.querySelectorAll('[data-mnav-close]').forEach(function (b) {
      b.addEventListener('click', function () { open(false); });
    });
    nav.addEventListener('click', function (e) {
      if (e.target === nav) open(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') open(false);
    });
  }

  /* ------------------------------------------------ kurv-skuffe */
  var Drawer = {
    el: null,
    init: function () {
      Drawer.el = document.querySelector('[data-drawer]');
      if (!Drawer.el) return;
      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-drawer-open]');
        if (openBtn) { e.preventDefault(); Drawer.open(); return; }
        if (e.target.closest('[data-drawer-close]')) { Drawer.close(); return; }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') Drawer.close();
      });
    },
    open: function () {
      if (!Drawer.el) return;
      Drawer.el.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
      var c = Drawer.el.querySelector('[data-drawer-close]');
      if (c) c.focus();
    },
    close: function () {
      if (!Drawer.el) return;
      Drawer.el.setAttribute('data-open', 'false');
      document.documentElement.style.overflow = '';
    },
    refresh: function () {
      return fetch(window.Shopify.routes.root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-drawer]');
          var current = document.querySelector('[data-drawer]');
          if (fresh && current) {
            var wasOpen = current.getAttribute('data-open');
            current.innerHTML = fresh.innerHTML;
            current.setAttribute('data-open', wasOpen || 'false');
            Drawer.el = current;
            /* Skuffens indhold er nyt — bind afkrydsningen igen */
            if (typeof initAccept === 'function') initAccept();
          }
          var count = tmp.querySelector('[data-cart-count]');
          document.querySelectorAll('[data-cart-count]').forEach(function (n) {
            if (count) n.textContent = count.textContent;
            n.hidden = !count || count.textContent.trim() === '0';
          });
          bindQty();
        });
    }
  };

  /* ------------------------------------------------ læg i kurv */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-cart-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add-btn]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Lægger i kurv…'; }

      var body = new FormData(form);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: body
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Kunne ikke lægge i kurv');
          return Drawer.refresh().then(Drawer.open);
        })
        .catch(function (err) {
          var slot = form.querySelector('[data-form-error]');
          if (slot) { slot.textContent = err.message; slot.hidden = false; }
          else alert(err.message);
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    });
  }

  /* ------------------------------------------------ antal + linjeændring */
  function changeLine(key, qty) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      } else {
        return Drawer.refresh();
      }
    });
  }

  function bindQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.bound === '1') return;
      wrap.dataset.bound = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = Math.max(parseInt(wrap.dataset.min || '1', 10), (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      if (wrap.dataset.line) {
        input.addEventListener('change', function () {
          changeLine(wrap.dataset.line, parseInt(input.value, 10) || 0);
        });
      }
    });

    document.querySelectorAll('[data-remove-line]').forEach(function (b) {
      if (b.dataset.bound === '1') return;
      b.dataset.bound = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(b.dataset.removeLine, 0);
      });
    });
  }

  /* ------------------------------------------------ produktgalleri */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gal) {
      var slides = gal.querySelectorAll('[data-slide]');
      var thumbs = gal.querySelectorAll('[data-thumb]');
      var show = function (id) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.slide === id); });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.thumb === id ? 'true' : 'false'); });
      };
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.dataset.thumb); });
      });
      gal.addEventListener('variant:change', function (e) {
        if (e.detail && e.detail.imageId) show(String(e.detail.imageId));
      });
    });
  }

  /* ------------------------------------------------ varianter */
  function initVariants() {
    document.querySelectorAll('[data-variants]').forEach(function (root) {
      var dataEl = root.querySelector('[data-variant-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      var btn = root.querySelector('[data-add-btn]');
      var stockEl = root.querySelector('[data-stock]');
      var stockTpl = stockEl ? stockEl.textContent.trim() : '';
      var stockMax = stockEl ? parseInt(stockEl.getAttribute('data-max') || '3', 10) : 3;
      var gallery = document.querySelector('[data-gallery]');

      var update = function () {
        var chosen = Array.prototype.map.call(
          root.querySelectorAll('[data-option-index]'),
          function (group) {
            var checked = group.querySelector('input:checked');
            return checked ? checked.value : null;
          }
        );
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        if (!match) return;

        idInput.value = match.id;

        if (priceEl) {
          var html = '<span>' + money(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<s>' + money(match.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
        }

        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? btn.dataset.labelAdd : btn.dataset.labelSold;
        }

        /* Antalsvælgeren skjules, når der kun er ét stk. tilbage */
        var qtyWrap = root.querySelector('[data-qty]');
        if (qtyWrap) {
          var kunEn = !!match.tracked && match.policy !== 'continue' && match.qty === 1;
          qtyWrap.hidden = kunEn;
          if (kunEn) { var qi = qtyWrap.querySelector('input'); if (qi) qi.value = 1; }
        }

        /* Lagerlinjen følger den valgte variant */
        if (stockEl) {
          var faa = match.tracked && match.available && match.qty > 0 && match.qty <= stockMax;
          stockEl.hidden = !faa;
          if (faa) stockEl.textContent = stockTpl.replace(/\d+/, match.qty);
        }

        if (gallery && match.featured_image) {
          gallery.dispatchEvent(new CustomEvent('variant:change', { detail: { imageId: match.featured_image.id } }));
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      };

      root.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) update();
      });
    });
  }

  /* ------------------------------------------------ gravering: tegntæller + skriftvisning */
  function initEngrave() {
    /* Felter med "Kun blokbogstaver": værdien gøres til store bogstaver,
       så det også står sådan i kurven og på ordren. Markøren bliver stående. */
    document.querySelectorAll('[data-versaler]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var a = inp.selectionStart, b = inp.selectionEnd, op = inp.value.toLocaleUpperCase('da-DK');
        if (op !== inp.value) { inp.value = op; try { inp.setSelectionRange(a, b); } catch (e) {} }
      });
    });
    document.querySelectorAll('[data-count-max]').forEach(function (input) {
      var out = document.querySelector('[data-count-for="' + input.id + '"]');
      if (!out) return;
      var upd = function () { out.textContent = input.value.length + ' / ' + input.dataset.countMax; };
      input.addEventListener('input', upd);
      upd();
    });

    var prev = document.querySelector('[data-font-preview]');
    if (!prev) return;
    var src = document.querySelector('[data-engrave-text]');
    var fonts = document.querySelectorAll('[data-font-family]');
    var choices = document.querySelectorAll('[data-engrave-choice]');

    /* Teksten i forhåndsvisningen: det kunden selv skriver, ellers det valgte
       ord ovenover (fx Kontor). Vælges det valg, der åbner tekstfeltet (fx
       Andet), står pladsholderen, indtil kunden skriver. */
    var tekst = function () {
      var valgt = document.querySelector('[data-engrave-choice]:checked');
      var binder = src && src.closest('[data-vis-ved]');
      var aabner = binder ? binder.getAttribute('data-vis-ved') : null;
      /* Et valgt ord vinder, medmindre det er valget, der åbner tekstfeltet */
      if (valgt && valgt.value !== aabner) return valgt.value;
      if (src && src.value.trim()) return src.value;
      return src && src.placeholder ? src.placeholder : (prev.dataset.placeholder || 'Din tekst');
    };

    var versaler = !!document.querySelector('[data-versaler]');
    var apply = function () {
      prev.textContent = versaler ? tekst().toLocaleUpperCase('da-DK') : tekst();
      var chosen = document.querySelector('[data-font-family]:checked');
      if (chosen) prev.style.fontFamily = "'" + chosen.dataset.fontFamily + "', serif";
    };

    if (src) src.addEventListener('input', apply);
    Array.prototype.forEach.call(choices, function (c) { c.addEventListener('change', apply); });
    fonts.forEach(function (f) {
      f.addEventListener('change', function () {
        prev.classList.add('is-swap');
        setTimeout(function () { apply(); prev.classList.remove('is-swap'); }, 180);
      });
    });
    apply();
  }

  /* ------------------------------------------------ reveal ved scroll */

  /* Hero-mosaikken: felter med flere billeder krydser mellem dem.
     Felterne skifter forskudt, så de ikke slår om samtidig. */
  function initHeroSkift() {
    var mosaik = document.querySelector('[data-hero-skift]');
    if (!mosaik) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sek = parseInt(mosaik.getAttribute('data-hero-skift'), 10);
    if (!sek || sek < 1) return;

    var felter = [];
    Array.prototype.forEach.call(mosaik.querySelectorAll('[data-tile-skift]'), function (felt, n) {
      var billeder = felt.querySelectorAll('.tile__media img');
      if (billeder.length < 2) return;
      felter.push({ billeder: billeder, i: 0, forskyd: n * 1.4 });
    });
    if (!felter.length) return;

    /* Ét ur til dem alle, og hvert felt regner selv ud, hvornår det er dets
       tur. Telefoner sætter timere på pause, når siden ikke er forrest — med
       forsinkede starttimere kom skiftet derfor aldrig i gang. Her er der
       intet at gå glip af: uret spørger bare, hvor lang tid der er gået. */
    var start = Date.now();

    function tik() {
      var gaaet = (Date.now() - start) / 1000;
      felter.forEach(function (f) {
        var skal = Math.floor((gaaet - f.forskyd) / sek);
        if (skal < 0) return;
        var maal = skal % f.billeder.length;
        if (maal === f.i) return;
        f.billeder[f.i].classList.remove('is-on');
        f.i = maal;
        f.billeder[f.i].classList.add('is-on');
      });
    }

    setInterval(tik, 500);

    /* Kommer siden frem igen efter at have ligget i baggrunden, indhentes
       skiftet med det samme i stedet for at vente på næste halve sekund. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tik();
    });
  }


  /* Farvevælger: rullelisten viser kun farverne til den valgte overflade,
     og prikken ved siden af skifter til den valgte farve. */
  function initFarver() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cpick]'), function (v) {
      var select = v.querySelector('[data-cpick-select]');
      var ui     = v.querySelector('[data-cpick-ui]');
      var knap   = v.querySelector('[data-cpick-knap]');
      var liste  = v.querySelector('[data-cpick-liste]');
      var dot    = v.querySelector('[data-cpick-dot]');
      var navnEl = v.querySelector('[data-cpick-navn]');
      var fald   = v.querySelector('[data-cpick-fald]');
      var note   = v.querySelector('[data-cpick-skaffes]');
      if (!select || !ui || !knap || !liste) return;

      /* Alle farver læses ud én gang, så listen kan bygges om,
         hver gang overfladen skifter. */
      var alle = [];
      Array.prototype.forEach.call(select.querySelectorAll('option'), function (o) {
        alle.push({
          type: o.parentNode && o.parentNode.getAttribute
            ? o.parentNode.getAttribute('data-cpick-group') : '',
          value: o.value,
          navn: o.textContent.trim(),
          hex: o.getAttribute('data-hex') || '',
          skaffes: o.getAttribute('data-skaffes') === '1'
        });
      });
      if (!alle.length) return;

      /* Fra nu af styrer vi visningen. Select-feltet bliver, fordi det er
         det, der følger med ordren — men det skjules for øjet. */
      ui.hidden = false;
      if (fald) fald.hidden = true;

      var aktuel = null;

      function vis(f) {
        aktuel = f;
        if (dot) dot.style.background = f && f.hex ? f.hex : 'transparent';
        if (navnEl) navnEl.textContent = f ? f.navn : '';
        if (note) note.hidden = !(f && f.skaffes);
        if (f) {
          select.value = f.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      function luk() {
        liste.hidden = true;
        knap.setAttribute('aria-expanded', 'false');
      }

      function aaben() {
        liste.hidden = false;
        knap.setAttribute('aria-expanded', 'true');
        var valgt = liste.querySelector('[aria-selected="true"]');
        if (valgt) valgt.scrollIntoView({ block: 'nearest' });
      }

      function byg(type) {
        var beholdt = aktuel ? aktuel.value : null;
        var passende = alle.filter(function (f) { return !type || f.type === type; });
        if (!passende.length) return;

        liste.innerHTML = '';
        var fandt = null;

        passende.forEach(function (f) {
          var r = document.createElement('button');
          r.type = 'button';
          r.className = 'cpick__valg';
          r.setAttribute('role', 'option');
          r.innerHTML = '<span class="cpick__dot cpick__dot--lille" style="background:'
            + (f.hex || 'transparent') + '"></span><span>' + f.navn + '</span>'
            + (f.skaffes ? '<span class="cpick__mark u-mono">skaffes</span>' : '');
          r.addEventListener('click', function () {
            liste.querySelectorAll('[aria-selected="true"]').forEach(function (x) {
              x.setAttribute('aria-selected', 'false');
            });
            r.setAttribute('aria-selected', 'true');
            vis(f);
            luk();
            knap.focus();
          });
          if (f.value === beholdt) { fandt = f; r.setAttribute('aria-selected', 'true'); }
          else r.setAttribute('aria-selected', 'false');
          liste.appendChild(r);
        });

        if (!fandt) {
          fandt = passende[0];
          var f0 = liste.querySelector('[role="option"]');
          if (f0) f0.setAttribute('aria-selected', 'true');
        }
        vis(fandt);
      }

      knap.addEventListener('click', function () {
        if (liste.hidden) aaben(); else luk();
      });

      document.addEventListener('click', function (e) {
        if (!v.contains(e.target)) luk();
      });

      v.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !liste.hidden) { luk(); knap.focus(); }
      });

      Array.prototype.forEach.call(v.querySelectorAll('[data-cpick-type]'), function (t) {
        t.addEventListener('change', function () { if (t.checked) { byg(t.value); luk(); } });
      });

      var start = null;
      Array.prototype.forEach.call(v.querySelectorAll('[data-cpick-type]'), function (t) {
        if (t.checked) start = t.value;
      });
      byg(start);
    });
  }


  /* Felter der først dukker op ved et bestemt valg.

     Et tekstfelt kan sættes til "Vis kun når der er valgt: Andet". Så ligger
     det skjult, indtil kunden vælger Andet i et valgfelt på siden. Skjules det
     igen, tømmes det og mister sit krav om at blive udfyldt — ellers kan
     formularen ikke sendes. */
  function initBetingedeFelter() {
    var felter = document.querySelectorAll('[data-vis-ved]');
    if (!felter.length) return;

    function opdater() {
      var valgt = [];
      document.querySelectorAll('.opt__row input:checked').forEach(function (i) {
        valgt.push(i.value);
      });
      document.querySelectorAll('select').forEach(function (sel) {
        if (sel.value) valgt.push(sel.value);
      });
      document.querySelectorAll('.pcheck input:checked').forEach(function (c) {
        if (c.dataset.label) valgt.push(c.dataset.label);
      });

      Array.prototype.forEach.call(felter, function (f) {
        var kraev = (f.getAttribute('data-vis-ved') || '').trim();
        if (!kraev) { f.hidden = false; return; }
        var vis = valgt.indexOf(kraev) !== -1;
        f.hidden = !vis;
        var input = f.querySelector('input, textarea');
        if (!input) return;
        if (vis) {
          if (input.dataset.varKraevet === '1') input.required = true;
        } else {
          if (input.required) input.dataset.varKraevet = '1';
          input.required = false;
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
        }
      });
    }

    document.addEventListener('change', opdater);
    opdater();
  }


  /* Kurven: knappen Til betaling kan først trykkes, når kunden har sat flueben
     ved handelsbetingelserne. Findes både på kurvesiden og i kurveskuffen. */
  function initAccept() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-accept]'), function (blok) {
      var boks = blok.querySelector('[data-accept-box]');
      if (!boks) return;

      /* Knappen står enten inde i samme blok eller lige efter den */
      var rod = blok.parentNode;
      var knap = rod ? rod.querySelector('[data-accept-btn]') : null;
      if (!knap) return;

      function opdater() {
        knap.disabled = !boks.checked;
        blok.classList.toggle('accept--mangler', !boks.checked);
      }

      boks.addEventListener('change', opdater);
      opdater();
    });
  }

  function initReveal() {
    /* Billeder i editorial, specialopgave og bannere træder frem bag en maske.
       Kun bokse, der rent faktisk indeholder et billede — ellers ville en tom
       boks blive klippet væk og se ud som om noget mangler. */
    document.querySelectorAll('.ed__media, .cta__media, .collban__media').forEach(function (el) {
      if (el.querySelector('img')) el.classList.add('reveal-mask');
    });

    /* giv hvert element i et gitter sin egen lille forsinkelse */
    document.querySelectorAll('.pgrid, .matgrid, .steps, .quotes, .shopby').forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (child, i) {
        child.style.setProperty('--i', i % 6);
      });
    });

    var targets = document.querySelectorAll('.reveal, .reveal-up, .reveal-mask');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) { io.observe(t); });

    /* Sikkerhedsnet.

       Et billede må aldrig blive stående usynligt, fordi udløseren ikke meldte
       til. Det skete på "Lise og Mathias" og specialopgave-blokken: masken blev
       lagt på ved indlæsning, og hvis højden ikke var faldet på plads endnu,
       kom meldingen aldrig. Derfor tjekker vi selv efter — ved scroll, ved
       ændret vinduesstørrelse, når billederne er hentet, og til sidst
       ubetinget. */
    function friGiv(altid) {
      var h = window.innerHeight;
      document.querySelectorAll('.reveal-mask:not(.is-in), .reveal-up:not(.is-in), .reveal:not(.is-in)')
        .forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (altid || (r.top < h * 1.2 && r.bottom > -h * 0.2)) el.classList.add('is-in');
        });
    }

    var tjek = null;
    function planlaeg() {
      if (tjek) return;
      tjek = setTimeout(function () { tjek = null; friGiv(false); }, 120);
    }
    window.addEventListener('scroll', planlaeg, { passive: true });
    window.addEventListener('resize', planlaeg, { passive: true });
    window.addEventListener('load', function () { friGiv(false); });

    setTimeout(function () { friGiv(false); }, 400);
    setTimeout(function () { friGiv(false); }, 1500);

    /* Efter otte sekunder er ingen animation vigtigere end at kunne se siden. */
    setTimeout(function () { friGiv(true); }, 8000);
  }

  /* ------------------------------------------------ beskedbjælke der skifter */
  function initAnnounce() {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var items = bar.querySelectorAll('[data-announce-item]');
    if (items.length < 2) return;

    var wait = parseInt(bar.dataset.interval, 10) || 5000;
    var i = 0;
    var timer;

    var next = function () {
      var cur = items[i];
      cur.classList.remove('is-on');
      cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 500);
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    };

    /* En fremhævet besked (data-hold) står flere gange så længe som de andre */
    var tid = function () { return wait * (parseInt(items[i].dataset.hold, 10) || 1); };
    var loop = function () { timer = setTimeout(function () { next(); loop(); }, tid()); };
    var start = function () { clearTimeout(timer); loop(); };
    var stop = function () { clearTimeout(timer); };

    start();
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { stop(); start(); }
    });
  }

  /* ------------------------------------------------ sidehovedet trækker sig sammen */
  function initHeader() {
    var hdr = document.querySelector('.hdr');
    if (!hdr) return;
    var ticking = false;
    var upd = function () {
      hdr.classList.toggle('is-scrolled', window.scrollY > 48);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(upd); ticking = true; }
    }, { passive: true });
    upd();
  }

  /* ------------------------------------------------ sortering på kollektion */
  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initMobileNav();
    Drawer.init();
    initAddToCart();
    bindQty();
    initGallery();
    initVariants();
    initEngrave();
    initReveal();
    initHeader();
    initSort();
    initHeroSkift();
    initFarver();
    initBetingedeFelter();
    initAccept();
    initAnnounce();
  });

  /* Genbind når tema-editoren indlæser en sektion igen */
  document.addEventListener('shopify:section:load', function () {
    bindQty(); initGallery(); initVariants(); initEngrave(); initReveal(); initHeader(); initSort(); initHeroSkift(); initFarver(); initBetingedeFelter(); initAccept(); Drawer.init();
  });
})();
